<template>
  <Head title="Projects" />

  <BreezeAuthenticatedLayout>
    <main class="container">

      <div class="c-header">
        <a href="" onclick="javascript:history.back(); return false;" class="c-header__back">
          <img src="/images/icons/icon-chevron-left.svg" alt="back">
        </a>
        <h2 class="c-header--h2">カテゴリー：編集</h2>
      </div>

      <div class="py-12">

        <div class="flex flex-col">

          <div class="grid place-content-center mt-10">
            <form @submit.prevent="updateCategory" class="bg-white shadow-md m-2 p-2 rounded">
              <div class="mt-24">
                <label for="title" class="block text-sm font-medium text-gray-700"> カテゴリー </label>
                <div class="mt-1">
                  <input type="text" id="name" wire:model.lazy="name" name="name" v-model="form.name" />
                </div>
              </div>

              <div class="mt-24">
                <label for="memo" class="block text-sm font-medium text-gray-700"> メモ </label>
                
                <div class="mt-1">
                  <textarea v-model="form.memo" name="memo" placeholder="備考欄"></textarea>
                </div>
              </div>

              <div class="mt-24">
                <button type="submit" class="c-button">更新する</button>
              </div>
            </form>
          </div>

        </div>

      </div>
    <Side />
    </main>
  </BreezeAuthenticatedLayout>
</template>

<script>
  import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
  import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
  import { Inertia } from '@inertiajs/inertia';
  import Side from '@/Shared/Side';

  export default {
    components: {
      BreezeAuthenticatedLayout,
      Head,
      Link,
      useForm,
      Inertia,
      Side,
    },

    props: {
      category: Object,
    },

    setup(props) {
      const form = useForm({
        name: props.category.name,
        memo: props.category.memo,
      });

      return { form };
    },

    methods: {
      updateCategory() {
        Inertia.post(`/categories/${this.category.id}`, {
        _method: 'put',
        name: this.form.name,
        memo: this.form.memo,
      })
      // this.form.put(route("projects.update", this.project.id));
      // },
    },
    }
  }
</script>
